define('lq/queryString',[
    'underscore',
    'lq/runtimeLocation'
], function (_, runtimeLocation) {
    'use strict';

    var getParametersFromQueryString = function () {
        var search = runtimeLocation.getSearch();
        if (!search) return {};

        var queryString = search.substr(1).split('&');

        if (!queryString) return {};

        var params = {};
        for (var i = 0; i < queryString.length; ++i) {
            var queryStringPart = queryString[i];
            var splitPosition = queryStringPart.indexOf('=');

            if (splitPosition) {
                var paramName = queryStringPart.substring(0, splitPosition);
                var paramValue = queryStringPart.substring(splitPosition + 1);
                params[paramName] = decodeURIComponent(paramValue.replace(/\+/g, " "));
            }
        }

        return params;
    };

    var QueryString = function (parameters) {
        this.parameters = parameters;
    };

    QueryString.initialize = function () {
        var queryString = new QueryString(getParametersFromQueryString());

        window.history.pushState = new Proxy(window.history.pushState, {
            apply: function (target, thisArg, argArray) {
                target.apply(thisArg, argArray);
                queryString.update();
            }
        });

        return queryString;
    };

    QueryString.prototype.getParameterNames = function () {
        return _.keys(this.parameters);
    };

    QueryString.prototype.getParameters = function () {
        return this.parameters;
    };

    QueryString.prototype.updateParameter = function (parameterName, value) {
        this.parameters[parameterName] = value;
    };

    QueryString.prototype.getValueOf = function (parameterName) {
        return this.parameters[parameterName];
    };

    QueryString.prototype.update = function () {
        this.parameters = getParametersFromQueryString();
    };

    return QueryString;
});
